import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import { isDevMode } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { ClarityService } from './app/services/clarity.service';
import { environment } from './environments/environment';

if (isDevMode()) {
  (window as any).__REDUX_DEVTOOLS_EXTENSION__ = undefined;
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ = undefined;
  // Use the EXACT string from the Firebase Console
  (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN =
    'A4324B33-A661-4302-8B02-5A04E34EC3B6';
  // console.log('App Check Debug Token initialized in main.ts');
}

Sentry.init({
  dsn: 'https://847bb95f6a43ecb6204b41cef59d5712@o518344.ingest.us.sentry.io/5627098',
  environment: environment.production ? 'production' : 'development',
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    Sentry.browserTracingIntegration(),
    // Registers the Replay integration,
    // which automatically captures Session Replays
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: environment.production ? 0.4 : 0.1,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/atchurch\.app\//],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: environment.production ? 0.1 : 0.05,
  replaysOnErrorSampleRate: 1.0,
});

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    if (environment.production === false) return;
    const clarity = appRef.injector.get(ClarityService);
    clarity.init(); // Start anonymous tracking immediately
  })
  .catch((err) => console.error(err));
